import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Requisition } from '../models/requisition';
import { RequisitionSap } from '../models/requisition-sap';

@Injectable({
  providedIn: 'root'
})
export class RequisitionService {

  constructor( private http:HttpClient ) { }

  postRequisition(requisition:Requisition) : Promise<Requisition> {
    return this.http.post<Requisition>('/api/purchases/requisition', requisition)
      .toPromise();
  }

  postRequisitionSap(requisitionSap:RequisitionSap) : Promise<any>{
    return this.http.post<any>('/api/purchases/requisition-sap', requisitionSap)
      .toPromise();
  }

  authorizeRequisition(requisition:Requisition) : Promise<Requisition> {
    return this.http.post<Requisition>('/api/purchases/requisition/' + requisition.id + '/authorize', {})
      .toPromise();
  }

  getRequisitionsByDates(date1:Date, date2:Date) : Promise<Requisition[]> {
    return this.http.get<Requisition[]>('/api/purchases/requisition', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  getOpenRequisitions() : Promise<Requisition[]> {
    return this.http.get<Requisition[]>('/api/purchases/requisition/open')
      .toPromise();
  }

  getRequisition(requisition_id) : Promise<Requisition> {
    return this.http.get<Requisition>('/api/purchases/requisition/' + requisition_id)
      .toPromise();
  }

  deleteRequisition(params) : Promise<any> {
    return this.http.get<any>('/api/purchases/requisition/delete', {params})
      .toPromise();
  }
}
